const API_URL = process.env.REACT_APP_BACKEND_URL;
// import Auth from '../../Helpers/auth';

async function httpSubcontractorLogin(pin, companyId, userId) {
  return await fetch(`${API_URL}/newsletters/sign-up`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ pin, companyId, userId }),
  });
}

export { httpSubcontractorLogin };
